import React from "react";
import error from "../img/error.png"

export const Textarea = (props) => {
    let {input, meta, ...restProps} = props;
    return <AutoContainer {...props}><textarea {...input} {...restProps}/></AutoContainer>
};

export const Input = (props) => {
    let {input, meta, ...restProps} = props;
    return <AutoContainer {...props}><input {...input} {...restProps}/></AutoContainer>
};

export const InputWithPlaceholder = (props) => {
    let {input, meta, ...restProps} = props;
    return <AutoContainerWithPlaceholder {...props}><input {...input} {...restProps}/></AutoContainerWithPlaceholder>
};

export const AutoContainer = ({input, meta, ...props}) => {
    let errors = meta.error && meta.touched;
    return(
        <div className={errors ? 'field-error field-normal' : 'field-normal'}>
                <div>{props.children}</div>
                {errors ? <div className='field-error__img-error'><img src={error} alt=""/></div> : null}
        </div>
    )
};

export const AutoContainerWithPlaceholder = ({input, meta, ...props}) => {
    let errors = meta.error && meta.touched;
    return(
        <div className={errors ? 'field-error field-normal' : 'field-normal'}>
            {props.children}
            <span className='label'>{props.placeholders}</span>
            {errors ? <div className='field-error__img-error'><img src={error} alt=""/></div> : null}
        </div>
    )
};
